import { MenuItemType } from '@inbody/ui';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import FactoryOutlinedIcon from '@mui/icons-material/FactoryOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import RunningWithErrorsOutlinedIcon from '@mui/icons-material/RunningWithErrorsOutlined';
import SchemaOutlinedIcon from '@mui/icons-material/SchemaOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';

// barrel(@/shared/lib/react-router)이 아니라 Urls 모듈을 직접 참조한다.
// barrel 은 Route -> layout -> menuItems 순으로 평가되므로, 여기서 barrel 을
// 거치면 Urls 초기화 전에 되돌아와 TDZ 에러가 난다.
import { IPH_ROLE } from '@/shared/components/auth/roles';
import { Urls } from '@/shared/lib/react-router/Urls';

/**
 * IPH 사이드 메뉴 (§5.1).
 *
 * 기능정의서의 화면 구성(§5.1)을 따라 'PO 관리' 그룹으로 묶는다. '발주 관리'
 * (IPH-07~10) 그룹은 해당 화면을 만들 때 여기에 추가한다.
 *
 * 아직 만들지 않은 화면은 넣지 않는다 — 눌러도 아무 일이 없는 항목을 미리 세워
 * 두면 어디까지 동작하는지 알 수 없기 때문이다.
 */
export const MENU_ITEMS: MenuItemType[] = [
  /*
    대시보드(IPH-01)는 루트('/')라 헤더 홈 버튼으로도 갈 수 있지만, 메뉴에
    없으면 그 경로를 모르는 사람은 들어갈 방법이 없다. 맨 위에 둔다 —
    로그인하면 처음 보는 화면이다.
  */
  {
    id: 'main',
    type: 'link',
    label: Urls.main.label,
    url: Urls.main.path,
    iconNode: <DashboardOutlinedIcon sx={{ fontSize: 18 }} />,
  },
  {
    id: 'po',
    type: 'expand',
    label: 'PO 관리',
    iconNode: <DescriptionOutlinedIcon sx={{ fontSize: 18 }} />,
    children: [
      {
        id: 'po-all',
        type: 'link',
        label: Urls.poAll.label,
        url: Urls.poAll.path,
        iconNode: <ListAltOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        id: 'po-action',
        type: 'link',
        label: Urls.poAction.label,
        url: Urls.poAction.path,
        iconNode: <PendingActionsOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        // IPH-04 는 구매검토자 전용이다(§2). 실제 노출 제어는 Keycloak role 이
        // 붙을 때 requireRoleList 로 지정한다 — 지금은 화면의 ReviewerOnly 가
        // 경계를 대신 표시한다.
        id: 'po-submitted',
        type: 'link',
        label: Urls.poSubmitted.label,
        url: Urls.poSubmitted.path,
        iconNode: <AssignmentTurnedInOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        id: 'po-late',
        type: 'link',
        label: Urls.poLate.label,
        url: Urls.poLate.path,
        iconNode: <RunningWithErrorsOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        id: 'delivery',
        type: 'link',
        label: Urls.delivery.label,
        url: Urls.delivery.path,
        iconNode: <LocalShippingOutlinedIcon sx={{ fontSize: 18 }} />,
      },
    ],
  },
  {
    // '발주 관리'(IPH-07~10) 그룹 — 생산계획 → 일괄/단품 발주 → 발주 예정
    // 순으로 둔다. 자재를 담아 상신하는 실제 흐름과 같은 순서다.
    id: 'order',
    type: 'expand',
    label: '발주 관리',
    iconNode: <FactoryOutlinedIcon sx={{ fontSize: 18 }} />,
    children: [
      {
        id: 'plan',
        type: 'link',
        label: Urls.plan.label,
        url: Urls.plan.path,
        iconNode: <EventNoteOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        id: 'mrp',
        type: 'link',
        label: Urls.mrp.label,
        url: Urls.mrp.path,
        iconNode: <ShoppingCartOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        id: 'single-order',
        type: 'link',
        label: Urls.singleOrder.label,
        url: Urls.singleOrder.path,
        iconNode: <Inventory2OutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        id: 'pending-order',
        type: 'link',
        label: Urls.pendingOrder.label,
        url: Urls.pendingOrder.path,
        iconNode: <SendOutlinedIcon sx={{ fontSize: 18 }} />,
      },
    ],
  },
  /*
    구매 지표(IPH-11)는 PO·발주와 달리 '실행' 이 아니라 '돌아보기' 라
    그룹에 넣지 않고 최상위에 둔다 — 하위 항목도 없다(탭으로 나뉜다).
  */
  {
    id: 'kpi',
    type: 'link',
    label: Urls.kpi.label,
    url: Urls.kpi.path,
    iconNode: <InsightsOutlinedIcon sx={{ fontSize: 18 }} />,
  },
  /*
    데이터 점검 — 매일 ERP 적재·BOM 전개 알림과 값 변경 이력.
    쌓이기만 하고 볼 방법이 없던 것들이라 맨 아래 따로 둔다(일상 업무가 아니라
    "무언가 어긋났을 때" 찾아오는 자리다).
  */
  {
    id: 'system',
    type: 'link',
    label: Urls.system.label,
    url: Urls.system.path,
    iconNode: <RunningWithErrorsOutlinedIcon sx={{ fontSize: 18 }} />,
  },
  /*
    기준정보(IPH-12) — ERP 가 모르는, 우리가 손으로 정하는 값들.

    화면이 여럿이라 그룹으로 묶는다. 거래처가 맨 위인 이유는 들어오는 빈도이고,
    나머지는 '무엇이 무엇을 정하는가' 순이다 — 제조구분은 거래처의 선택지를,
    직원은 품목 담당자를 정한다.

    조회는 USER 도 되므로 `requireRoleList` 를 걸지 않는다. 기준정보는 "왜 이렇게
    계산됐나"의 답이라서, 고칠 수 없는 사람도 읽을 일이 있다 — 쓰기 버튼은 각
    화면이 권한으로 잠근다.
  */
  {
    id: 'master',
    type: 'expand',
    label: '기준정보',
    iconNode: <BusinessOutlinedIcon sx={{ fontSize: 18 }} />,
    children: [
      {
        id: 'supplier',
        type: 'link',
        label: Urls.supplier.label,
        url: Urls.supplier.path,
        iconNode: <BusinessOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        /*
          품목은 거래처 다음이다 — 들어오는 빈도가 거래처에 이어 가장 높고,
          주 거래처를 거래처 목록에서 고르므로 읽는 순서도 이쪽이 뒤다.
        */
        id: 'item',
        type: 'link',
        label: Urls.item.label,
        url: Urls.item.path,
        iconNode: <Inventory2OutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        /*
          BOM 은 품목 다음이다 — 분류가 품목군 단위라 품목을 보고 나서 오게 된다.
          판매 비율도 같은 품목군 키라 한 화면에 묶었다(메뉴를 둘로 나누면 양쪽에서
          같은 품목군을 또 골라야 한다).
        */
        id: 'bom',
        type: 'link',
        label: Urls.bom.label,
        url: Urls.bom.path,
        iconNode: <SchemaOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        id: 'manufacturing-type',
        type: 'link',
        label: Urls.manufacturingType.label,
        url: Urls.manufacturingType.path,
        iconNode: <PrecisionManufacturingOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        id: 'employee',
        type: 'link',
        label: Urls.employee.label,
        url: Urls.employee.path,
        iconNode: <BadgeOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        id: 'warehouse',
        type: 'link',
        label: Urls.warehouse.label,
        url: Urls.warehouse.path,
        iconNode: <WarehouseOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        id: 'holiday',
        type: 'link',
        label: Urls.holiday.label,
        url: Urls.holiday.path,
        iconNode: <CalendarMonthOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        id: 'calc-param',
        type: 'link',
        label: Urls.calcParam.label,
        url: Urls.calcParam.path,
        iconNode: <TuneOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        id: 'category-map',
        type: 'link',
        label: Urls.categoryMap.label,
        url: Urls.categoryMap.path,
        iconNode: <AccountTreeOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        /* 양식은 '우리가 정하는 값'이라 적재 묶음 앞에 둔다. */
        id: 'doc-template',
        type: 'link',
        label: Urls.docTemplate.label,
        url: Urls.docTemplate.path,
        iconNode: <DescriptionOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        /*
          ERP 적재는 다른 기준정보와 성격이 다르다 — 값을 정하는 곳이 아니라
          "들어온 값이 언제 것인가" 를 보는 곳이라 맨 아래 둔다.
        */
        id: 'erp-sync',
        type: 'link',
        label: Urls.erpSync.label,
        url: Urls.erpSync.path,
        iconNode: <StorageOutlinedIcon sx={{ fontSize: 18 }} />,
      },
      {
        /* 적재 원본 대사 — PO 목록이 아니라서 발주 메뉴가 아니라 여기 있다. */
        id: 'erp-po-line',
        type: 'link',
        label: Urls.erpPoLine.label,
        url: Urls.erpPoLine.path,
        iconNode: <ReceiptLongOutlinedIcon sx={{ fontSize: 18 }} />,
      },
    ],
  },
];

/**
 * 관리자 메뉴 — `LayoutSideMenuV2` 의 `adminMenuItemsList` 로 넘긴다.
 *
 * 일반 메뉴와 **구분선 + '관리자' 라벨로 갈라져** 맨 아래 붙는다(in-learning ·
 * voe · 포털과 같은 자리다). 그룹(expand)으로 묶지 않는 이유는, 이것들이 '메뉴의
 * 한 분류' 가 아니라 **성격이 다른 영역**이기 때문이다 — 권한을 회수하면 그
 * 사용자가 화면에 못 들어오고, 가입을 거절하면 계정이 삭제된다.
 *
 * `requireRoleList` 로 ADMIN 만 메뉴를 본다. 화면 안쪽의 `AdminOnly` 는 그대로
 * 둔다 — 메뉴를 감추는 것과 URL 을 직접 치고 들어오는 것을 막는 건 다른 일이다.
 *
 * 항목이 role 로 전부 가려지면 구분선과 라벨도 함께 사라진다(컴포넌트가
 * `hasVisibleAdminMenu` 로 처리한다) — 빈 '관리자' 칸이 남지 않는다.
 */
export const ADMIN_MENU_ITEMS: MenuItemType[] = [
  {
    id: 'role-permission',
    type: 'link',
    label: Urls.rolePermission.label,
    url: Urls.rolePermission.path,
    iconNode: <ShieldOutlinedIcon sx={{ fontSize: 18 }} />,
    requireRoleList: [IPH_ROLE.ADMIN],
  },
  {
    // ISP(외부 협력사 포털) 사용자의 가입 신청 승인·거절 — 사용자 단위다(회사
    // 단위 허용은 '기준정보 > 거래처' 의 ISP 사용 허용). ISP 에는 role 이 없어
    // 권한 관리 화면은 따로 두지 않는다 — 소속 협력사만 지정한다.
    id: 'external-approval',
    type: 'link',
    label: Urls.externalApproval.label,
    url: Urls.externalApproval.path,
    iconNode: <HowToRegOutlinedIcon sx={{ fontSize: 18 }} />,
    requireRoleList: [IPH_ROLE.ADMIN],
  },
];
